import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-learn-by-course',
  templateUrl: './learn-by-course.component.html',
  styleUrls: ['./learn-by-course.component.scss']
})
export class LearnByCourseComponent implements OnInit {

  course_id:any
  user_id:any
  slug:any
  constructor(private apiService: ApiService , private activatedroute : ActivatedRoute,
              private route:Router ) { 
    this.activatedroute.paramMap.subscribe(params => { 
      this.user_id = JSON.parse(localStorage.getItem('user')).id
      this.course_id = params.get('id'); 
      this.slug = params.get('slug'); 

  });
  }

  ngOnInit(): void {
  }
  openInNewTab(slug,studentId): void {
    window.open(`/student-lms?slug=${slug}&studentId=${studentId}`, '_blank');
  }
  goToClass(){
    this.route.navigate(['/learn/my-classes',this.user_id])
  }
gotoSessions(){
  this.route.navigate(['/learn/my-sessions',this.course_id])
}
}
